import React, { useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import ReactGA from "react-ga4";
import Home from './Home';
import Suggests from './Suggests';
import Contact from './Contact';
import Login from './Login';
import Invites from './Invites';
import AddInvites from './AddInvites';
import Tables from './Tables';
import Expenses from './Expenses';
import Buy from './Buy';
import InvitationResponse from './InvitationResponse ';
import Info from './Info';
import TermsOfUse from './TermsOfUse';
import PrivacyPolicy from './PrivacyPolicy';
import GeneralInvitation from './GeneralInvitation';
import AgentChatDashboard from './AgentChatDashboard';
import GiftPage from './GiftPage';
import GiftThankYou from "./GiftThankYou";
import ShowGiftsPage from "./ShowGiftsPage";
import WorkersCheckinPage from './WorkersCheckinPage';


ReactGA.initialize("G-D8JD4T46K0");

function SiteRoutes() {
    const location = useLocation();
  
    useEffect(() => {
      if (location.hash) {
        const target = document.getElementById(location.hash.slice(1));
        if (target) {
          target.scrollIntoView({ behavior: "smooth", block: "start" });
        } else {
          window.scrollTo(0, 0);
        }
      } else {
        window.scrollTo(0, 0);
      }

      ReactGA.send({ hitType: "pageview", page: location.pathname });

    }, [location]);

  return (
    <>
    <Routes>
    <Route path='/' element={<Home/>}/>
    <Route path='/suggests' element={<Suggests/>}/>
    <Route path='/contact' element={<Contact/>}/>
    <Route path='/login' element={<Login/>}/>
    <Route path='/my-invites' element={<Invites/>}/>
    <Route path='/add-invites' element={<AddInvites/>}/>
    <Route path='/personal_info' element={<Info/>}/>
    <Route path='/tables' element={<Tables/>}/>
    <Route path='/expenses' element={<Expenses/>}/>
    <Route path='/buy' element={<Buy/>}/>
    <Route path="/invitation/confirm/:uuid" element={<InvitationResponse lang="he" />} />
    <Route path="/invitation/confirm/en/:uuid" element={<InvitationResponse lang="en" />} />
    <Route path="/invitation/confirm/fr/:uuid" element={<InvitationResponse lang="fr" />} />
    <Route path="/invitation/confirm/he/:uuid" element={<InvitationResponse lang="he" />} />
    <Route path='/useterms' element={<TermsOfUse />}/>
    <Route path='/privacy' element={<PrivacyPolicy />}/>
    <Route path='/chat' element={<AgentChatDashboard />}/>
    <Route path="/invitation/general/:slug" element={<GeneralInvitation />} />
    <Route path="/invite/:invitation_token/gift" element={<GiftPage />} />
    <Route path="/gift/thank-you" element={<GiftThankYou />} />
    <Route path="/gifts" element={<ShowGiftsPage />} />
    <Route path="/workers/:eventToken" element={<WorkersCheckinPage />} />
    </Routes>
    </>
  )
}

export default SiteRoutes;